import { FullContainer } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import {
  ALARMS_REPORTS_PAGE,
  CONSUMPTION_REPORTS_PAGE,
  CONTROL_TOWER_PAGE,
  CONVOYS_PAGE,
  DELIVERY_GEOFENCES_PAGE,
  DELIVERY_REPORTS_PAGE,
  DOOR_REPORTS_PAGE,
  EVIDENCE_REPORT_DETAIL_PAGE,
  EVIDENCES_REPORTS_PAGE,
  GEOFENCES_PAGE,
  GPT_DETAIL_PAGE,
  JOURNEYS_PAGE,
  LINKS_PAGE,
  LIVE_PAGE,
  LIVE_STATUS_PAGE,
  NOTIFICATION_EVIDENCE_DETAIL_PAGE,
  NOTIFICATION_EVIDENCES_PAGE,
  NOTIFICATION_PAGE,
  PATHS_REPORTS_PAGE,
  PLACES_PAGE,
  PUBLIC_LIVE_PAGE,
  REPORTS_PAGE,
  REQUEST_VIDEO_PAGE,
  ROUTE_REPORTS_PAGE,
  SECONDARIES_PAGE,
  STREAM_PAGE,
  TELEMETRY_REPORTS_PAGE,
  TRACKING_PAGE,
} from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { isPublicPageState, pageState } from '../../storage/app';
import Map from '../map/Map';
import PublicMap from '../map/PublicMap';

function PageLayout() {
  const page = useRecoilValue(pageState);
  const isPublicPage = useRecoilValue(isPublicPageState);
  const { css } = useStyles();

  const mapPages = [
    LIVE_PAGE.id,
    REQUEST_VIDEO_PAGE.id,
    STREAM_PAGE.id,
    GEOFENCES_PAGE.id,
    DELIVERY_GEOFENCES_PAGE.id,
    JOURNEYS_PAGE.id,
    TRACKING_PAGE.id,
    SECONDARIES_PAGE.id,
    PLACES_PAGE.id,
    REPORTS_PAGE.id,
    ROUTE_REPORTS_PAGE.id,
    PATHS_REPORTS_PAGE.id,
    ALARMS_REPORTS_PAGE.id,
    EVIDENCES_REPORTS_PAGE.id,
    EVIDENCE_REPORT_DETAIL_PAGE.id,
    TELEMETRY_REPORTS_PAGE.id,
    CONSUMPTION_REPORTS_PAGE.id,
    DOOR_REPORTS_PAGE.id,
    DELIVERY_REPORTS_PAGE.id,
    CONVOYS_PAGE.id,
    LINKS_PAGE.id,
    NOTIFICATION_PAGE.id,
    LIVE_STATUS_PAGE.id,
    CONTROL_TOWER_PAGE.id,
    GPT_DETAIL_PAGE.id,
    PUBLIC_LIVE_PAGE.id,
    NOTIFICATION_EVIDENCES_PAGE.id,
    NOTIFICATION_EVIDENCE_DETAIL_PAGE.id,
  ];
  const hasMap = mapPages.includes(page);

  return (
    <FullContainer
      flexible
      classNames={css({
        position: 'relative',
        overflow: 'hidden',
      })}
    >
      {hasMap && !isPublicPage && <Map />}
      {hasMap && isPublicPage && <PublicMap />}
      <Outlet />
    </FullContainer>
  );
}

export default memo(PageLayout);
